import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Table } from 'antd';

@inject('ecodeDemoStore', 'ecodeGenreStore')
@observer
class App extends React.Component {
  static defaultProps = {
		formPrefixCls: 'sys-basic',
		prefixCls: 'sys-user',
  }
  onPageChange = (page, pageSize) => {
    const { getParams, ecodeDemoStore: { getTag, getDeletedDemo, getLogList, getEcodeLogList, setMobxState, activitykey, customerDownloadLog, searchFormValue, getEcodeRole, getMemberList, getAppManage } } = this.props;
    setMobxState({ pageNum: page, pageSize });
    const params = toJS(searchFormValue);
    const param = getParams(params);
    if (activitykey === "downloadlog") {
      if (param.startDate) {
        param.startDate = param.startDate.format('YYYY-MM-DD');
        param.endDate = param.endDate.format('YYYY-MM-DD');
      }
      getEcodeLogList({ pageNum: page, pageSize, ...param });
    } else if (activitykey === "tagmanage") {
      getTag({ pageNum: page, pageSize });
    } else if (activitykey === "demorenew") {
      getDeletedDemo({ pageNum: page, pageSize, ...param });
    } else if (activitykey === "cusdownloadlog") {
      if (param.startDate) {
        param.startDate = param.startDate.format('YYYY-MM-DD');
        param.endDate = param.endDate.format('YYYY-MM-DD');
      }
      customerDownloadLog({ pageNum: page, pageSize, ...param });
    } else if(activitykey === 'ecoderole'){
      getEcodeRole({ pageNum: page, pageSize, ...param });
    } else if(activitykey === 'memberlist'){
      getMemberList({ pageNum: page, pageSize, ...param });
    } else if (activitykey === 'appmanage') {
      getAppManage({ pageNum: page, pageSize, ...param });
    } else {
      getLogList({ pageNum: page, pageSize, ...param });
    }
  }
  rowSelection = () => {
    const { ecodeDemoStore: { activitykey, setMobxState, tagSelectedRowKeys, demoSelectedRowKeys } } = this.props;
    if (activitykey === 'tagmanage') {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          setMobxState({ tagSelectedRowKeys: selectedRowKeys, tagSelectedRows: selectedRows });
        },
        selectedRowKeys: toJS(tagSelectedRowKeys)
      }
    } else if (activitykey === 'demorenew') {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          setMobxState({ demoSelectedRowKeys: selectedRowKeys, tagSelectedRows: selectedRows });
        },
        selectedRowKeys: toJS(demoSelectedRowKeys)
      }
    }
    return null;
  }
  render() {
    const { ecodeDemoStore: { loading, datas, getColumns, count, pageNum, pageSize }, ecodeGenreStore: {getGenres} } = this.props;
    return (
      <Table
        rowKey="id"
        loading={loading}
        dataSource={toJS(datas)}
        columns={getColumns(getGenres)}
        // scroll={{ y : 600 }}
        pagination={{
          showTotal: (total) => `共${total}条`,
          total: count,
          pageNum,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSize,
          onShowSizeChange: this.onPageChange,
          onChange: this.onPageChange,
        }}
        rowSelection={this.rowSelection()}
      />
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/Table.js